<template>
  <div class="table-wrapper">
    <table>
      <caption class="visually-hidden">
        {{
          $t('C2W_CAMPAIGNS_REPORT.HEADER')
        }}
      </caption>
      <thead>
        <tr>
          <th>{{ $t('C2W_CAMPAIGNS_REPORT.TABLE.CREATED_AT') }}</th>
          <th>{{ $t('C2W_CAMPAIGNS_REPORT.FILTERS.SOURCE') }}</th>
          <th>{{ $t('C2W_CAMPAIGNS_REPORT.FILTERS.HEADLINE') }}</th>
          <th>{{ $t('C2W_CAMPAIGNS_REPORT.TABLE.CONTACT') }}</th>
          <th>{{ $t('C2W_CAMPAIGNS_REPORT.TABLE.PHONE') }}</th>
          <th>{{ $t('C2W_CAMPAIGNS_REPORT.TABLE.CAMPAIGN_IMAGE') }}</th>
          <th>{{ $t('C2W_CAMPAIGNS_REPORT.TABLE.CAMPAIGN_VIDEO') }}</th>
          <th>{{ $t('C2W_CAMPAIGNS_REPORT.TABLE.LINK_TO_CONVERSATION') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in paginatedData"
          :key="index"
          :class="{ 'striped-row': index % 2 !== 0 }"
        >
          <td>{{ formatDate(item.created_at) }}</td>
          <td>{{ item.source || '-' }}</td>
          <td>{{ item.headline || '-' }}</td>
          <td>{{ item.contact_name || '-' }}</td>
          <td>{{ item.formatted_phone_number || item.phone_number || '-' }}</td>
          <td>
            <div v-if="item.image_url" class="fallback-text">
              <a
                :href="item.image_url"
                target="_blank"
                rel="noopener noreferrer"
                :title="item.image_url"
              >
                {{ truncate(item.image_url) }}
              </a>
            </div>
          </td>
          <td>
            <span>{{ item.video_url ? 'url' : 'null' }}</span>
          </td>
          <td>
            <a
              v-if="item.link_conversation"
              :href="item.link_conversation"
              target="_blank"
              rel="noopener noreferrer"
              :title="item.link_conversation"
            >
              {{ truncate(item.link_conversation) }}
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="pagination">
      <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">
        {{ $t('C2W_CAMPAIGNS_REPORT.PAGINATION.PREVIOUS') }}
      </button>
      <span>
        {{ $t('C2W_CAMPAIGNS_REPORT.PAGINATION.PAGE') }} {{ currentPage }}
        {{ $t('C2W_CAMPAIGNS_REPORT.COMMON.OF') }} {{ totalPages }}
      </span>
      <button
        @click="goToPage(currentPage + 1)"
        :disabled="currentPage === totalPages"
      >
        {{ $t('C2W_CAMPAIGNS_REPORT.PAGINATION.NEXT') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CampaignsTable',
  props: {
    campaignsData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 100,
      erroredImages: [],
    };
  },
  computed: {
    sortedData() {
      return [...this.campaignsData].sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    },
    paginatedData() {
      const start = (this.currentPage - 1) * this.perPage;
      return this.sortedData.slice(start, start + this.perPage);
    },
    totalPages() {
      return Math.ceil(this.campaignsData.length / this.perPage);
    },
  },
  methods: {
    formatDate(dateString) {
      return new Date(dateString).toLocaleString('pt-BR', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      });
    },
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
      }
    },
    truncate(text, maxLength = 50) {
      if (!text || typeof text !== 'string') return '-';
      return text.length > maxLength
        ? text.slice(0, maxLength - 3) + '...'
        : text;
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  max-height: 600px;
  overflow-y: auto;
  border: 1px solid #ddd;
}

table {
  width: 100%;
  border-collapse: collapse;
  min-width: 1000px;
}

thead {
  background-color: #2563eb;
  color: white;
}

th,
td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #eaeaea;
  word-break: break-word;
  vertical-align: top;
}

.striped-row {
  background-color: #f9f9f9;
}

a {
  color: #2563eb;
  text-decoration: underline;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 16px;
  align-items: center;
}

.pagination button {
  background-color: #2563eb;
  color: white;
  border: none;
  padding: 8px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

td span {
  display: inline-block;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.fallback-text {
  font-size: 12px;
  color: #555;
  max-width: 200px;
  word-break: break-word;
}
</style>
